import React, { useEffect, useRef, useState } from "react";
import "./Footer.css";
import logodark from "../images/Dataharbor-dark.png";

export const Footer = () => {
  const footerRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.15 } // Triggers when 15% of the footer is visible
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) observer.unobserve(footerRef.current);
    };
  }, []);

  return (
    <footer className="footer" ref={footerRef}>
      <div className="container">
        <div className="footer-content">
          
          {/* Left section slides in from the LEFT */}
          <div
            className={`footer-left-group animate-side slide-left ${
              isInView ? "in-view" : ""
            }`}
          >
            <div className="footer-section">
              <h3>DataHarbor</h3>
              <ul>
                <li><a href="/contact" className="footer-link">Contact Us</a></li>
                <li><a href="/about" className="footer-link">About Us</a></li>
                <li><a href="/ourteam" className="footer-link">Our Team</a></li>
                <li><a href="/services" className="footer-link">Services</a></li>
              </ul>
            </div>
          </div>

          {/* Right section slides in from the RIGHT */}
          <div
            className={`footer-section footer-right-section animate-side slide-right ${
              isInView ? "in-view" : ""
            }`}
          >
            <h3>Contact Info</h3>
            <ul className="footer-contact-list">
              <li>
                <span>Phone:</span>{" "}
                <a
                  href="https://wa.me/9613105562"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link phone-link"
                >
                  <i className="fa-brands fa-whatsapp whatsapp-icon"></i>
                  +961 3 105 562
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/96171825874"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link phone-link pindent"
                >
                  <i className="fa-brands fa-whatsapp whatsapp-icon"></i>
                  +961 71 825 874
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/96170316466"
                  target="_blank"
                  rel="noreferrer"
                  className="footer-link phone-link pindent"
                >
                  <i className="fa-brands fa-whatsapp whatsapp-icon"></i>
                  +961 70 316 466
                </a>
              </li>
              <li>
                <span>Email:</span>{" "}
                <a href="mailto:info@dataharborlb.com" className="footer-link">
                  info@dataharborlb.com
                </a>
              </li>
            </ul>

            <div className="social-links-inline">
              <a
                href="https://www.instagram.com/dataharborlb?igsh=eHZtcnViN3oxZGsz"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="instagram-link"
              >
                <i className="icons fa-brands fa-instagram"></i>
                <span>Follow us on Instagram</span>
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar slides in from the LEFT */}
      <div
        className={`footer-bottom animate-side slide-left ${
          isInView ? "in-view" : ""
        }`}
      >
        <a href="/" className="logo-wrapper">
          <img
            src={logodark}
            alt="DataHarbor Logo"
            className="footer-logo"
          />
        </a>

        <small className="copyright">
          &copy; {new Date().getFullYear()} DataHarbor - All Rights Reserved.
        </small>
      </div>
    </footer>
  );
};